import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserHappyPayTopupAddDialogComponent } from '@features/user/components/user-happy-pay-topup-add-dialog/user-happy-pay-topup-add-dialog.component';
import { UserHappyPayWithdrawalAddDialogComponent } from '@features/user/components/user-happy-pay-withdrawal-add-dialog/user-happy-pay-withdrawal-add-dialog.component';
import {
  HappyPayTopUp,
  HappyPayWithdrawal,
} from '@features/user/interfaces/happy-pay.interface';
import { User } from '@features/user/interfaces/user.interface';
import { UserService } from '@features/user/services/user.service';
import {
  faAngleRight,
  faCalendarDays,
  faSquarePlus,
} from '@fortawesome/free-solid-svg-icons';
import { DialogService } from 'primeng/dynamicdialog';
import { LayoutService } from 'src/app/layout/services/layout.service';

interface topUpHappyPay {
  name: string | number;
  value: string | number;
}
@Component({
  selector: 'fc-user-happy-pay',
  templateUrl: './user-happy-pay.component.html',
  styleUrls: ['./user-happy-pay.component.css'],
})
export class UserHappyPayComponent implements OnInit, OnDestroy {
  topup_details: any;
  // define fontawesome
  faSquarePlus = faSquarePlus;
  faCalenderDays = faCalendarDays;
  faAngleRight = faAngleRight;

  // degine dialog
  displayDialogWithdrawal!: boolean;
  displayDialogTopUp!: boolean;
  displayDialogBankAccount!: boolean;

  // define dropdown
  paymentMethod!: topUpHappyPay[];

  user?: User;
  happyPayNavs: any = [
    {
      name: 'All',
      link: '/user/happy-pay/transaction',
    },
    {
      name: 'Top Up',
      link: '/user/happy-pay/top-up',
    },
    {
      name: 'Withdrawal',
      link: '/user/happy-pay/withdrawal',
    },
    {
      name: 'Bank Account',
      link: '/user/happy-pay/bank-account',
    },
  ];
  constructor(
    private userService: UserService,
    private dialogService: DialogService,
    private layoutService: LayoutService
  ) {
    if (this.layoutService.isMobile$.value) {
      this.layoutService.setFooterVisibility(false);
      this.layoutService.setMobileLayoutConfig({
        headerNav: {
          backButton: true,
          title: 'Happy Pay',
          searchButton: false,
        },
        bottomNav: {
          visibillity: false,
        },
      });
    }
    this.paymentMethod = [
      { name: 'Credit Card', value: 1 },
      { name: 'Bank Transfer', value: 2 },
    ];
  }

  ngOnInit(): void {
    this.userService.currentUserValue.subscribe((user: User) => {
      this.user = user;
    });
  }
  ngOnDestroy(): void {
    if (this.layoutService.isMobile$.value) {
      this.layoutService.setFooterVisibility(true);
      this.layoutService.setDefaultMobileLayoutConfig();
    }
  }

  onHappyPayWithDrawal() {
    let style;
    if (this.layoutService.isMobile$.value) {
      style = {
        'max-height': '100%',
        width: '100vh',
        height: '100vh',
        overflow: 'hidden',
      };
    } else {
      style = {
        'border-radius': '1rem',
        overflow: 'hidden',
      };
    }
    const ref = this.dialogService.open(
      UserHappyPayWithdrawalAddDialogComponent,
      {
        dismissableMask: true,
        closable: true,
        showHeader: false,
        width: '500px',
        contentStyle: {
          padding: '0',
        },
        style: style,
      }
    );

    ref.onClose.subscribe((happyPayWithdrawal: HappyPayWithdrawal) => {
      if (happyPayWithdrawal) {
      }
    });
  }
  onHappyPayTopup() {
    let style;
    if (this.layoutService.isMobile$.value) {
      style = {
        'max-height': '100%',
        width: '100vh',
        height: '100vh',
        overflow: 'hidden',
      };
    } else {
      style = {
        'border-radius': '1rem',
        overflow: 'hidden',
      };
    }
    const ref = this.dialogService.open(UserHappyPayTopupAddDialogComponent, {
      dismissableMask: true,
      closable: true,
      showHeader: false,
      width: '500px',
      contentStyle: {
        padding: '0',
      },
      style: style,
    });

    ref.onClose.subscribe((happyPayTopUp: HappyPayTopUp) => {
      if (happyPayTopUp) {
      }
    });
  }
}
